var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['feedbacks']},[_c('div',{staticClass:"feedback-full"},[_c('h3',[_vm._v("Feedback Summary for "+_vm._s(_vm.feedback.created_date))]),_c('div',{staticClass:"feedback-text",domProps:{"innerHTML":_vm._s(_vm.formattedSummary)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }